module.exports = __webpack_public_path__ + "static/media/fixedDeposit.668cd804.svg";